import { render, staticRenderFns } from "./ViewerModelList.vue?vue&type=template&id=594841b4&scoped=true"
import script from "./ViewerModelList.vue?vue&type=script&lang=js"
export * from "./ViewerModelList.vue?vue&type=script&lang=js"
import style0 from "./ViewerModelList.vue?vue&type=style&index=0&id=594841b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594841b4",
  null
  
)

export default component.exports